import Date from '../prototypes/Date'
import merge from '../functions/merge';

export default {
	entity() {
		return merge({}, {
			hour_rate: 0,
			contact_id: null,
			compound_type: null,
			lead_id: null,
			quote_id: null,
			order_id: null,
			due_start: (new Date()).format('Y-m-d'),
			due_end: (new Date()).format('Y-m-d'),
			end_time: '07:00',
			from: '07:00',
			to: '07:00',
			department_id: null,
			employee_id: null,
			remarks: null,
			name: null,
			email: null,
			phone: null,
			type: 'other',
			requirements: [],
			customer_desc: '',
			task_group_id: null,
			reference: '',
			reminder: false,
			details: {
				files: [],
				photos: [],
				duration: 4 * 60,
				address: {
					address: '',
					zip: '',
					city: '',
					country: ''
				},
				packaging: {}
			},
			_embedded: {
				employee: {
					name: ''
				},
				contact: {
					name: '',
					address: '',
					zip: '',
					city: ''
				}
			}
		});
	},
	save(axios, entity) {
		return new Promise(function (resolve) {
			if (entity.id) {
				axios
					.put('/planning/tasks/' + entity.id + '/', entity)
					.then(function (r) {
						
						resolve(r.data);
					}, function () {
						
						resolve(false);
					});
			} else {
				axios
					.post('/planning/tasks/', entity)
					.then(function (r) {
						resolve(r.data);
					}, function () {
						resolve(false);
					});
			}
		});
	},
	read(axios, id) {
		return new Promise(function (resolve) {
			axios
				.get('/planning/tasks/' + id + '/')
				.then(function (r) {
					resolve(r.data);
				}, function () {
					resolve(false);
				});
		});
	},
	readPage(axios, year, month, day) {
		return new Promise(function (resolve) {
			axios
				.get('/tasks/' + year + '/' + month + '/' + day + '/')
				.then(function (r) {
					resolve(r.data);
				}, function () {
					resolve(false);
				});
		});
	},
	delete(axios, id) {
		return new Promise(function (resolve) {
			axios
				.delete('/planning/tasks/' + id + '/')
				.then(function () {
					resolve(true);
				}, function () {
					resolve(false);
				});
		});
	}
};